import '@/helpers/util';
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from '@/App';
import Error from '@/Error';
import * as general from '@/sections/general'
import * as apptokens from '@/sections/apptokens'
import * as users from '@/sections/users'
import * as billings from '@/sections/billings'
import * as images from '@/sections/images'
import i18next from 'i18next';
import { exists } from 'i18next/dist/commonjs';

var sections = [general, users, billings, apptokens, images];
// var sections = [general, users, apptokens, images];
Vue.use(VueRouter);

var routes = [];

//Add routes from submodules
for (let section of sections) {
  if (section.routes) {
    routes = routes.concat(
      section.routes.map(r => {
        //add children to meta
        r.meta = r.meta || {};
        r.meta.children = r.children || [];
        return r;
      })
    );
  }
}

//Init router
var router = new VueRouter({
  routes: [{
    path: '/:lang([a-z]{2})?',
    component: App,
    children: routes.map(r => {r.path = r.path.ltrim('/'); return r;}),
    meta: {
      root: true,
    },
  },
  {
    path: '*',
    component: Error,
  }
],
  //routes,
  scrollBehavior (to, from, savedPosition) {
    try {
      var element = to.matched[to.matched.length-1].instances.default.$el;
      //return {x: 0, y: Math.max(0, element.getBoundingClientRect().top - 100)};
    } catch (e) {
      //top
      //return {x: 0, y: 0};
    }
  },
});

router.beforeEach((to, from, next) => {
  if (!to.params) {
    to.params = {};
  }
  if (to.params.lang) {
    i18next.changeLanguage(to.params.lang);
  }
  if (from.params && from.params.lang && !to.params.lang) {
    to.params.lang = from.params.lang;
    next({name: to.name, params: to.params});
  } else {
    next();
  }
});

//Add submodule guards to router
for (let section of sections) {
  if (section.hasOwnProperty('guard')) {
    section.guard(router);
  }
}

//global mixin
Vue.mixin({
  beforeRouteLeave (to, from, next) {
    if (typeof this.title === 'string') {
      this.title = null;
    }
    next();
  }
});

export default router;



// WEBPACK FOOTER //
// ./src/routes.js